import { useRef, useState } from 'react';
import { BankOutlined, UserOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout as AntLayout, Button } from 'antd';
import { useSelector } from 'react-redux';

import './Layout.css';

import AppMainHeader from "./MainHeader";
import AppMainSider from "./MainSider";
import LoadingSpinner from '../LoadingSpinner';
import IDPLoggedinIssue from '../IDPLoggedinIssue';

const { Content } = AntLayout;

function MainLayout(props: any) {
	const user = useSelector((state: any) => state.auth.user)
	const username: string = user?.profile?.email ?? user?.profile?.upn;
	const [loading, setLoading] = useState(false)
	const [inlineCollapsed, setInlineCollapsed] = useState<boolean>(false)
	const [hideSider, setHideSider] = useState(true);
	const reference = useRef<any>();
	const isSameUserSession = (username.toLowerCase() === String(localStorage.getItem("email")).toLowerCase() || (localStorage.getItem("domainLogin") === "true"))

	const siderItems = [
		{
			label: "Accounts",
			key: "accounts",
			icon: <BankOutlined />,
		},
		{
			label: "Admins",
			key: "admins",
			icon: <UserOutlined />,
		}
	]

	function toggleSider() {
		reference.current['style']['display'] = hideSider ? 'none' : 'block'
		reference.current['style']['z-index'] = hideSider ? '1' : '0'
		reference.current['style']['transition-duration'] = '0.5s'
		setHideSider(!hideSider)
	}

	return <>
		{
			(loading)
				? <AntLayout className='content-empty-role-layout'>
					<LoadingSpinner />
				</AntLayout>
				: <AntLayout>
					{
						isSameUserSession &&
						<AppMainHeader
							loading={loading}
							button={<div className='mobile-side-toggle-button-div'>
								<Button
									type='primary'
									className='mobile-side-toggle-button'
									icon={hideSider ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
									onClick={() => toggleSider()}
								>
								</Button>
							</div>
							}
						/>
					}

					<AntLayout className="app-sider">
						{
							isSameUserSession ? (
								<>
									<AppMainSider siderItems={siderItems} inlineCollapsed={inlineCollapsed} setInlineCollapsed={setInlineCollapsed} reference={reference} />

									<AntLayout
										className="content-layout"
										onClick={() => {
											if (!hideSider) {
												toggleSider()
											}
										}}
									>
										<Content className="content">
											{props.children}
										</Content>
									</AntLayout>
								</>
							) : <IDPLoggedinIssue />
						}
					</AntLayout>
				</AntLayout>
		}
	</>
}

export default MainLayout;
